var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.28 0H40.96C18.35 0 0 18.35 0 40.96v696.32c0 22.61 18.35 40.96 40.96 40.96h696.32c22.61 0 40.96-18.35 40.96-40.96V40.96C778.24 18.35 759.89 0 737.28 0zm-40.96 696.32H81.92V81.92h614.4v614.4zm245.76 143.36v102.4h-102.4V1024h143.36c22.61 0 40.96-18.35 40.96-40.96V839.68h-81.92zm-417.382 102.4h220.364V1024H524.698v-81.92zm-197.018 0v-102.4h-81.92v143.36c0 22.61 18.35 40.96 40.96 40.96h143.36v-81.92h-102.4zm655.36-696.32H839.68v81.92h102.4v102.4H1024V286.72c0-22.61-18.35-40.96-40.96-40.96zM942.08 524.7H1024v220.363h-81.92V524.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.7fe174a648d644418db25933c743dcea.svg";
export { ForwardRef as ReactComponent };